import axios from 'axios'

export default () => {
    return {
        sites: '',

        api: {
            foundation: '',
            teams: '',
            college: '',
            homes: '',
            marriage: '',
            leadership: '',
            press: '',
        },

        perPage: 12,
        collection: '',

        siteData: {
            foundation: {
                page: 1,
                finished: false,
                running: false,
            },
            teams: {
                page: 1,
                finished: false,
                running: false,
            },
            college: {
                page: 1,
                finished: false,
                running: false,
            },
            homes: {
                page: 1,
                finished: false,
                running: false,
            },
            marriage: {
                page: 1,
                finished: false,
                running: false,
            },
            leadership: {
                page: 1,
                finished: false,
                running: false,
            },
            retreat: {
                page: 1,
                finished: false,
                running: false,
            },
            press: {
                page: 1,
                finished: false,
                running: false,
            },
        },

        items: [],

        filters: {
            location: {
                selected: ['all'],
                selections: [],
            },
            retreatName: {
                selected: ['all'],
                selections: [],
            },
            topic: {
                selected: ['all'],
                selections: [],
            },
            stageoflife: {
                selected: ['all'],
                selections: [],
            },
            season: {
                selected: ['all'],
                selections: [],
            },
            orgSize: {
                selected: ['all'],
                selections: [],
            },
            ministryType: {
                selected: ['all'],
                selections: [],
            },
            audience: {
                selected: ['all'],
                selections: [],
            },
            eventName: {
                selected: ['all'],
                selections: [],
            },
        },

        filtered: true,

        aggregatedData: {
            totalAPI: 0,
            finishedAPI: 0,
        },

        finished: false,

        // π ----
        // :: MOUNTED ---------------------------::
        // ____
        mounted(sites, collection, proxy) {
            this.sites = sites
            this.collection = collection

            const params = new URLSearchParams(window.location.search)

            Object.keys(this.filters).forEach(key => {
                if (params.get(key)) {
                    this.filters[key].selected = params.get(key).split(',')
                }
            })

            Object.keys(this.api).forEach((key, value) => {
                let ministry = ''

                if (key !== 'foundation') {
                    ministry = `${key}.`
                }

                this.api[key] = `//${ministry}${proxy}/wp-admin/admin-ajax.php`
            })

            this.fetchInit()
            this.filterInit()
        },

        // π ----
        // :: FETCH INIT ---------------------------::
        // ____
        fetchInit() {
            if (this.sites === 'all') {
                this.fetchAllSites()
            } else if (this.sites === 'foundation') {
                this.fetchEntries(this.api.foundation, this.sites)
            } else if (this.sites === 'teams') {
                this.fetchEntries(this.api.teams, this.sites)
            } else if (this.sites === 'college') {
                this.fetchEntries(this.api.college, this.sites)
            } else if (this.sites === 'homes') {
                this.fetchEntries(this.api.homes, this.sites)
            } else if (this.sites === 'marriage') {
                this.fetchEntries(this.api.marriage, this.sites)
            } else if (this.sites === 'leadership') {
                this.fetchEntries(this.api.leadership, this.sites)
            } else if (this.sites === 'retreat') {
                this.fetchEntries(this.api.retreat, this.sites)
            } else if (this.sites === 'press') {
                this.fetchEntries(this.api.press, this.sites)
            }
        },

        openGrid() {
            const open = gsap.timeline()

            open.to(this.$refs.cardGrid, {
                duration: 0.5,
                height: this.$refs.cardGrid.scrollHeight,
                ease: 'quint.inOut',
            }).to(
                this.$refs.gridCover,
                {
                    duration: 0.3,
                    autoAlpha: 0,
                    onComplete: () => ScrollTrigger.refresh(),
                },
                '<0.3',
            )
        },

        closeGrid() {
            const close = gsap.timeline()
            close.to(this.$refs.gridCover, { duration: 0.3, autoAlpha: 1 }).to(
                this.$refs.cardGrid,
                {
                    duration: 0.5,
                    height: 180,
                    ease: 'quint.inOut',
                    onComplete: () => ScrollTrigger.refresh(),
                },
                '<0',
            )
        },

        // π ----
        // :: FETCH ENTRIES ---------------------------::
        // ____
        fetchEntries(apiURL, apiName) {
            const requestData = new FormData()
            const pageNumber = this.getPage(apiName)

            requestData.append('action', 'fetch_events')
            requestData.append('collection', this.collection)
            requestData.append('page', pageNumber)
            requestData.append('per_page', this.perPage)

            // :: Filters ------------ //
            requestData.append('filter_location', this.filters.location.selected)
            requestData.append('filter_retreat_name', this.filters.retreatName.selected)
            requestData.append('filter_topic', this.filters.topic.selected)
            requestData.append('filter_stageoflife', this.filters.stageoflife.selected)
            requestData.append('filter_season', this.filters.season.selected)
            requestData.append('filter_org_size', this.filters.orgSize.selected)
            requestData.append('filter_ministry_type', this.filters.ministryType.selected)
            requestData.append('filter_audience', this.filters.audience.selected)
            requestData.append('filter_event_name', this.filters.eventName.selected)

            this.anyMore(apiURL, apiName)

            axios
                .post(apiURL, requestData)
                .then(response => {
                    if (response.data.entries != '') {
                        const entries = response.data.entries

                        if (this.filtered) {
                            this.items = entries
                            this.filtered = false
                        } else {
                            const mergedItems = this.items.concat(entries)
                            this.items = mergedItems
                        }

                        if (this.sites === 'all') {
                            this.logAPI(apiName)
                        }

                        this.updatePage(apiName)
                    } else {
                        this.finishedFetch(apiName)
                    }

                    setTimeout(() => {
                        this.openGrid()
                    }, 600)
                })
                .catch(error => {
                    console.log(error)
                })
        },

        // π ----
        // :: FETCH FROM ALL SITES ---------------------------::
        // ____
        fetchAllSites() {
            const APIs = Object.entries(this.api)

            for (const [apiName, siteAPI] of APIs) {
                if (apiName !== 'press') {
                    this.fetchEntries(siteAPI, apiName)
                }
            }
        },

        // π ----
        // :: CHECK IF THERE ARE ANYMORE ENTRIES ---------------------------::
        // ____
        anyMore(apiURL, apiName) {
            const requestData = new FormData()
            const pageNumber = this.getPage(apiName) + 1

            requestData.append('action', 'fetch_events')
            requestData.append('collection', this.collection)
            requestData.append('page', pageNumber)
            requestData.append('per_page', this.perPage)

            // :: Filters ------------ //
            requestData.append('filter_location', this.filters.location.selected)
            requestData.append('filter_retreat_name', this.filters.retreatName.selected)
            requestData.append('filter_topic', this.filters.topic.selected)
            requestData.append('filter_stageoflife', this.filters.stageoflife.selected)
            requestData.append('filter_season', this.filters.season.selected)
            requestData.append('filter_org_size', this.filters.orgSize.selected)
            requestData.append('filter_ministry_type', this.filters.ministryType.selected)
            requestData.append('filter_audience', this.filters.audience.selected)
            requestData.append('filter_event_name', this.filters.eventName.selected)

            axios
                .post(apiURL, requestData)
                .then(response => {
                    if (response.data.entries == '') {
                        this.finishedFetch(apiName)
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },

        // π ----
        // :: GET A SITE'S COLLECTION PAGE NUMBER ---------------------------::
        // ____
        getPage(site) {
            if (site === 'foundation') {
                return this.siteData.foundation.page
            } else if (site === 'teams') {
                return this.siteData.teams.page
            } else if (site === 'college') {
                return this.siteData.college.page
            } else if (site === 'homes') {
                return this.siteData.homes.page
            } else if (site === 'marriage') {
                return this.siteData.marriage.page
            } else if (site === 'leadership') {
                return this.siteData.leadership.page
            } else if (site === 'press') {
                return this.siteData.press.page
            }
        },

        // π ----
        // :: UPDATE A SITE'S COLLECTION PAGE NUMBER ---------------------------::
        // ____
        updatePage(site) {
            if (site === 'foundation') {
                this.siteData.foundation.page += 1
            } else if (site === 'teams') {
                this.siteData.teams.page += 1
            } else if (site === 'college') {
                this.siteData.college.page += 1
            } else if (site === 'homes') {
                this.siteData.homes.page += 1
            } else if (site === 'marriage') {
                this.siteData.marriage.page += 1
            } else if (site === 'leadership') {
                this.siteData.leadership.page += 1
            } else if (site === 'press') {
                this.siteData.press.page += 1
            }
        },

        // π ----
        // :: LOG API FOR "ALL" SITES ---------------------------::
        // ____
        logAPI(currentAPI) {
            if (currentAPI === 'foundation' && this.siteData.foundation.running === false) {
                this.siteData.foundation.running = true
                this.aggregatedData.totalAPI += 1
            } else if (currentAPI === 'teams' && this.siteData.teams.running === false) {
                this.siteData.teams.running = true
                this.aggregatedData.totalAPI += 1
            } else if (currentAPI === 'college' && this.siteData.college.running === false) {
                this.siteData.college.running = true
                this.aggregatedData.totalAPI += 1
            } else if (currentAPI === 'homes' && this.siteData.homes.running === false) {
                this.siteData.homes.running = true
                this.aggregatedData.totalAPI += 1
            } else if (currentAPI === 'marriage' && this.siteData.marriage.running === false) {
                this.siteData.marriage.running = true
                this.aggregatedData.totalAPI += 1
            } else if (currentAPI === 'leadership' && this.siteData.leadership.running === false) {
                this.siteData.leadership.running = true
                this.aggregatedData.totalAPI += 1
            }
        },

        // π ----
        // :: FINISHED FETCHING ---------------------------::
        // ____
        finishedFetch(finishedAPI) {
            if (this.sites === 'all') {
                this.markComplete(finishedAPI)
            } else {
                this.finished = true
            }
        },

        // π ----
        // :: MARK API AS COMPLETED ---------------------------::
        // ____
        markComplete(finishedAPI) {
            if (finishedAPI === 'foundation' && this.siteData.foundation.finished === false) {
                this.siteData.foundation.finished = true
                this.aggregatedData.finishedAPI += 1
            } else if (finishedAPI === 'teams' && this.siteData.teams.finished === false) {
                this.siteData.teams.finished = true
                this.aggregatedData.finishedAPI += 1
            } else if (finishedAPI === 'college' && this.siteData.college.finished === false) {
                this.siteData.college.finished = true
                this.aggregatedData.finishedAPI += 1
            } else if (finishedAPI === 'homes' && this.siteData.homes.finished === false) {
                this.siteData.homes.finished = true
                this.aggregatedData.finishedAPI += 1
            } else if (finishedAPI === 'marriage' && this.siteData.marriage.finished === false) {
                this.siteData.marriage.finished = true
                this.aggregatedData.finishedAPI += 1
            } else if (finishedAPI === 'leadership' && this.siteData.leadership.finished === false) {
                this.siteData.leadership.finished = true
                this.aggregatedData.finishedAPI += 1
            } else if (finishedAPI === 'press' && this.siteData.press.finished === false) {
                this.siteData.press.finished = true
                this.aggregatedData.finishedAPI += 1
            }

            this.allDone()
        },

        // π ----
        // :: ALL DONE? ---------------------------::
        // ____
        allDone() {
            if (this.aggregatedData.finishedAPI === this.aggregatedData.totalAPI) {
                this.finished = true
            }
        },

        // π ----
        // :: FILTER INIT ---------------------------::
        // ____
        filterInit() {
            let api

            if (this.sites === 'foundation') {
                api = this.api.foundation
            } else if (this.sites === 'teams') {
                api = this.api.teams
            } else if (this.sites === 'college') {
                api = this.api.college
            } else if (this.sites === 'homes') {
                api = this.api.homes
            } else if (this.sites === 'marriage') {
                api = this.api.marriage
            } else if (this.sites === 'leadership') {
                api = this.api.leadership
            } else if (this.sites === 'press') {
                api = this.api.press
            }

            /* :: Load Filters Based on Selected Collection
            {+} ---------------------------------- */
            let taxonomiesToFetch = []
            
            if (this.collection === 'event' || this.collection === 'adventure' || this.collection === 'retreat') {
                taxonomiesToFetch.push('location')
            } else {
                taxonomiesToFetch.push('topics')
            }

            if (this.collection === 'retreat') {
                taxonomiesToFetch.push('retreat-name', 'stage-of-life', 'retreat-topic', 'retreat-season')
            } else if (this.collection === 'adventure') {
                taxonomiesToFetch.push('retreat-name', 'adventure-topic')
            } else if (this.collection === 'event') {
                taxonomiesToFetch.push('organization-size', 'ministry-type', 'audience', 'event-name')
            }
            
            if (this.sites === 'all') {
                this.fetchAllFilters(taxonomiesToFetch)
            } else if (api) {
                this.fetchBatchedFilters(api, taxonomiesToFetch)
            }
        },

        fetchBatchedFilters(apiURL, taxonomies) {
            const requestData = new FormData()
            
            requestData.append('taxonomies', taxonomies.join(','))
            requestData.append('action', 'fetchAllTaxonomies')
            
            axios
                .post(apiURL, requestData)
                .then(response => {
                    if (response.data) {
                        // Process each taxonomy in the response
                        for (const [taxonomy, terms] of Object.entries(response.data)) {
                            let filter
                            
                            if (taxonomy === 'location') {
                                filter = this.filters.location.selections
                            } else if (taxonomy === 'topics') {
                                filter = this.filters.topic.selections
                            } else if (taxonomy === 'adventure-topic') {
                                filter = this.filters.topic.selections
                            } else if (taxonomy === 'retreat-topic') {
                                filter = this.filters.topic.selections
                            } else if (taxonomy === 'retreat-name') {
                                filter = this.filters.retreatName.selections
                            } else if (taxonomy === 'stage-of-life') {
                                filter = this.filters.stageoflife.selections
                            } else if (taxonomy === 'retreat-season') {
                                filter = this.filters.season.selections
                            } else if (taxonomy === 'organization-size') {
                                filter = this.filters.orgSize.selections
                            } else if (taxonomy === 'ministry-type') {
                                filter = this.filters.ministryType.selections
                            } else if (taxonomy === 'audience') {
                                filter = this.filters.audience.selections
                            } else if (taxonomy === 'event-name') {
                                filter = this.filters.eventName.selections
                            }
                            
                            if (filter && terms) {
                                for (let i = 0; i < terms.length; i++) {
                                    if (terms[i].name && !filter.some(item => item.slug === terms[i].slug)) {
                                        filter.push(terms[i])
                                    }
                                }
                            }
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },

        fetchAllFilters(taxonomies) {
            const APIs = Object.values(this.api)

            for (const siteAPI of APIs) {
                this.fetchBatchedFilters(siteAPI, taxonomies)
            }
        },

        // π ----
        // :: FILTER COLLECTION ---------------------------::
        // ____
        /**
         * Once a filter is selected, we need to bind that slug to the appropriate _filter_.
         * Then re-fetch items the filters set through _fetchInit()_.
         */
        filterCollection(filterKey, filterSlug) {
            let newFilter
            let filter

            console.log(`Filter Key is: ${filterKey}`)
            console.log(`Filter Slug is: ${filterSlug}`)

            /* :: Location
            {+} ---------------------------------- */
            filter = this.filterCheck('location', filterKey, filterSlug, this.filters.location.selected)
            if (filter) {
                this.filters.location.selected = filter
                newFilter = true
                filter = false
            }

            /* :: Topic
            {+} ---------------------------------- */
            filter = this.filterCheck(
                ['topic', 'adventure-topic', 'retreat-topic'],
                filterKey,
                filterSlug,
                this.filters.retreatName.selected,
            )
            if (filter) {
                this.filters.retreatName.selected = filter
                newFilter = true
                filter = false
            }

            /* :: Retreat Name
            {+} ---------------------------------- */
            filter = this.filterCheck('retreat-name', filterKey, filterSlug, this.filters.retreatName.selected)
            if (filter) {
                this.filters.retreatName.selected = filter
                newFilter = true
                filter = false
            }

            /* :: Stage of Life
            {+} ---------------------------------- */
            filter = this.filterCheck('stage-of-life', filterKey, filterSlug, this.filters.stageoflife.selected)
            if (filter) {
                this.filters.stageoflife.selected = filter
                newFilter = true
                filter = false
            }

            /* :: Retreat Season
            {+} ---------------------------------- */
            filter = this.filterCheck('retreat-season', filterKey, filterSlug, this.filters.season.selected)
            if (filter) {
                this.filters.season.selected = filter
                newFilter = true
                filter = false
            }

            /* :: Organization Size
            {+} ---------------------------------- */
            filter = this.filterCheck('organization-size', filterKey, filterSlug, this.filters.orgSize.selected)
            if (filter) {
                this.filters.orgSize.selected = filter
                newFilter = true
                filter = false
            }

            /* :: Ministry Type
            {+} ---------------------------------- */
            filter = this.filterCheck('ministry-type', filterKey, filterSlug, this.filters.ministryType.selected)
            if (filter) {
                this.filters.ministryType.selected = filter
                newFilter = true
                filter = false
            }

            /* :: Audience
            {+} ---------------------------------- */
            filter = this.filterCheck('audience', filterKey, filterSlug, this.filters.audience.selected)
            if (filter) {
                this.filters.audience.selected = filter
                newFilter = true
                filter = false
            }

            /* :: Event Name
            {+} ---------------------------------- */
            filter = this.filterCheck('event-name', filterKey, filterSlug, this.filters.eventName.selected)
            if (filter) {
                this.filters.eventName.selected = filter
                newFilter = true
                filter = false
            }

            if (newFilter) {
                this.filterRun()
            }
        },

        filterRun() {
            this.closeGrid()
            setTimeout(() => {
                this.resetCollection()
                this.filtered = true
                this.fetchInit()
                this.setUrlFilters()
            }, 600)
        },

        filterCheck(filterType, filterKey, filterSlug, filterSelected) {
            if (Array.isArray(filterType)) {
                if (!filterType.includes(filterKey)) {
                    return
                }
            } else {
                if (filterKey !== filterType) {
                    return
                }
            }

            if (filterSlug !== 'all') {
                filterSelected = array.remove(filterSelected, 'all')
            } else {
                filterSelected = ['all']
            }

            if (!filterSelected.includes(filterSlug)) {
                filterSelected.push(filterSlug)
            } else if (filterSlug !== 'all') {
                filterSelected = array.remove(filterSelected, filterSlug)
            }

            if (!filterSelected.length) {
                filterSelected = ['all']
            }

            return filterSelected
        },

        // π ----
        // :: SET URL FILTERS ---------------------------::
        // ____
        setUrlFilters() {
            const query = Object.keys(this.filters)
                .filter(key => !this.filters[key].selected.includes('all'))
                .map(key => `${key}=${this.filters[key].selected}`)
                .join('&')

            window.history.replaceState(window.history.state, '', query ? `?${query}` : window.location.pathname)
        },

        // π ----
        // :: RESET ---------------------------::
        // ____
        /**
         * Resets the _items_ array and each site's _page_
         */
        resetCollection() {
            this.siteData.foundation.page = 1
            this.siteData.teams.page = 1
            this.siteData.college.page = 1
            this.siteData.homes.page = 1
            this.siteData.marriage.page = 1
            this.siteData.leadership.page = 1
            this.siteData.retreat.page = 1
            this.finished = false
            this.items = []
        },
    }
}
